import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["video"]
  static values = { loopCount: Number }

  connect() {
    this.loopCount = this.loopCountValue || 2
    this.currentLoop = 0
    this.initializeVideo()
  }

  initializeVideo() {
    this.videoTarget.addEventListener('ended', this.handleVideoEnded.bind(this))
  }

  handleVideoEnded() {
    this.currentLoop++

    if (this.currentLoop < this.loopCount) {
      // Reiniciar el video para el siguiente loop
      this.videoTarget.currentTime = 0
      this.videoTarget.play()
    } else {
      // Después de 2 loops, pausar el video
      this.videoTarget.pause()
      this.currentLoop = 0 // Reset para futuras reproducciones
    }
  }
}
